import React,{useEffect} from 'react'
import {Link} from 'react-router-dom'
import {AiFillYoutube,AiFillInstagram,AiFillFacebook} from 'react-icons/ai'
import { useGlobalContext } from '../context.js'


const Speaker = () => {
    const {devices,addToCart} = useGlobalContext()
    useEffect(()=>{
        return window.scrollTo(0,0)
    },[])
    return (
        <>
        <div className="headphone_main">
        {devices[1].map((item)=>{
            return (
                <div className='headphone_container' key={item.id}>
                    <div className='headphone_img'>
                        <img src={`../${item.img}`} alt="" />
                    </div>
                    <div className='headphone_text'>
                        <h3>{item.title}</h3>
                        <p>{item.info}</p>
                        <div className='item_price'>
                        <h4>Amount: ${item.price}</h4>
                        {item.inCart ? 
                        <div>
                            <button disabled className="disabled">InCart</button>
                            <Link to='/cart' className='link'><button className='gotocart'>Go To Cart</button></Link>
                        </div> : <button onClick={() => addToCart(item.id)}>Add To Cart</button>  }
                        </div>
                    </div>
                </div>
            )
          })}  
        </div>
        <div className="section_5">
                <div className="left_side">
                    <h3>bringing you to the best audio gear</h3>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex cupiditate nobis, molestiae natus fugit alias officia laboriosam hic aspernatur eligendi temporibus asperiores sequi blanditiis reprehenderit.</p>
                </div>
                <div className="right_side">
                    <img src="../img/girl_listen.jpg" alt="" />
                </div>
            </div>
            <div className="footer">
            <footer>
                <div className="footer_left">
                    <h3>audiophile</h3>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia, magnam delectus! Distinctio iure obcaecati hic omnis officiis eveniet nesciunt, dignissimos recusandae debitis quam rem, illo at repellendus laudantium beatae nemo.</p>
                    <p>Copyright 2021 All Rights Reserved</p>
                </div>
                <div className="footer_right">
                <div className="nav_link">
                        <ul className="link_group">
                            <li>
                                <Link className="link" to='/'>Home</Link>
                            </li>
                            <li>
                                <Link className="link" to='/headphone'>Headphones</Link>
                            </li>
                            <li>
                                <Link className="link" to='/speaker'>Speakers</Link>
                            </li>
                            <li>
                                <Link className="link" to='/earphone'>Earphones</Link>
                            </li>
                        </ul>
                        <div className='social_footer'>
                            <Link className='social' to=''>
                            <AiFillFacebook/>
                            </Link>
                            <Link className='social' to=''>
                            <AiFillInstagram/>
                            </Link>
                            <Link className='social' to=''>
                            <AiFillYoutube/>
                            </Link>
                        </div>
                    </div>
                </div>
            </footer>
            </div>
        </>
    )
}

export default Speaker
